import { render, staticRenderFns } from "./compalint-user-set.vue?vue&type=template&id=4bc981b6&scoped=true&"
import script from "./compalint-user-set.vue?vue&type=script&lang=js&"
export * from "./compalint-user-set.vue?vue&type=script&lang=js&"
import style0 from "./compalint-user-set.vue?vue&type=style&index=0&id=4bc981b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc981b6",
  null
  
)

export default component.exports